import styled from "@emotion/styled";
import PropTypes from "prop-types";

import { HtmlContent } from "../../../HtmlContent";
import styles from "./Separator.style";

const SeparatorStyled = styled.div((props) => ({ ...styles(props) }));

const Separator = ({ className, text, hasLargeSpacing, ...rest }) => (
    <SeparatorStyled className={className} hasText={text} largeSpacing={hasLargeSpacing} {...rest}>
        <span className="separator_wave" />
        {text && (
            <>
                <HtmlContent content={text} className="separator_text" wrapperComponent="div" />
                <span className="separator_wave" />
            </>
        )}
    </SeparatorStyled>
);

Separator.propTypes = {
    className: PropTypes.string,
    text: PropTypes.string,
    hasLargeSpacing: PropTypes.bool,
};

Separator.defaultProps = {
    className: undefined,
    text: undefined,
    hasLargeSpacing: false,
};

export default Separator;
